module.exports = __webpack_public_path__ + "img/1f367.a41351a.svg";